import React, { Component } from 'react'
import { Grid, Box} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import SmallVideoPreviewBox from './SmallVideoPreviewBox'
import useStyles from './styles/VideoRowItemStyle'

class VideoRowItem extends Component {

  render() {
    const classes = this.props.classes
    return (
      <Grid container
        style={{cursor: 'pointer'}}
        onClick={()=> this.props.onVideoClicked()}
        className={classes.rowContainer}
      >
        <Grid container direction="row" className={`section-three-items-item-small-card`}>
          { /* The video player preview */}
          <Grid
            container
            item
            alignItems='stretch'
            justify='center'
            lg={5} md={5} sm={5}
          >
            {/* The video player preview */}
            <SmallVideoPreviewBox height={this.props.height} videoDetails={this.props.videoDetails} />
          </Grid>

          {/* The video description */}
          <Grid
            container
            item
            lg={7} md={7} sm={7}
            direction="column"
            alignItems="flex-start"
            justify="flex-start"
          >
            <Grid item>
              <Box className={`${classes.mainTitle} section-three-items-item-small-title`}>
                {this.props.videoDetails.title}
              </Box>
            </Grid>
            <Grid item hidden={isWidthDown('sm', this.props.width)}>
              <Box className={`${classes.secondaryTitle} section-three-items-item-small-subtitle`}>
                {this.props.videoDetails.description}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(useStyles)(withWidth()(VideoRowItem))
